const { addFilter } = require('./criteria');
const { jsonToGraphFilterToJsonToGraphObject } = require('./helper');

/**
 * Builds the JSON as an object that can be supplied to jsonToGraphQLQuery for downstream execution
 * by the Data Access EEDM endpoint.
 * @param queryName The properly-cased GraphQL query name to execute. Ex: constituentPersons.
 * @param queryBuilderJson The javascript object (not JSON string) output from the query builder.
 * @param fields The optional fields to retrieve in json-to-graphQL format.  Ex: { id: true, gender: true } Default: { id: true }
 * @param ids The optional list of IDs to further refine the query.
 * @returns The resulting JSON object to be supplied to jsonToGraphQLQuery.
 */
const queryBuilderObjectToJsonToGraphObject = (queryName, queryBuilderJson, fields, ids = []) => {
    const jsonToGraphQLFilter = {};

    // build filter
    if (queryBuilderJson) {
        addFilter(queryBuilderJson, jsonToGraphQLFilter);
    }
    return jsonToGraphFilterToJsonToGraphObject(
        queryName,
        jsonToGraphQLFilter,
        fields,
        ids,
    );
};

module.exports = { queryBuilderObjectToJsonToGraphObject };
